function required(name: keyof ImportMetaEnv): string {
  const value = import.meta.env[name]
  if (!value || typeof value !== 'string') {
    throw new Error(`Configuração obrigatória ausente: ${name}`)
  }
  return value
}

const nearDueDays = Number(import.meta.env.VITE_NEAR_DUE_DAYS ?? '3')
if (!Number.isInteger(nearDueDays) || nearDueDays < 1) {
  throw new Error('VITE_NEAR_DUE_DAYS deve ser um número inteiro positivo.')
}

export const appConfig = Object.freeze({
  name: import.meta.env.VITE_APP_NAME ?? 'Controle de Tarefas',
  version: '1.1',
  timezone: import.meta.env.VITE_APP_TIMEZONE ?? 'America/Sao_Paulo',
  nearDueDays,
  supabaseUrl: required('VITE_SUPABASE_URL'),
  supabaseAnonKey: required('VITE_SUPABASE_ANON_KEY'),
})
